// extracted by mini-css-extract-plugin
export var cardHeader = "_ff-0";
export var reorderHandle = "_ff-3";
export var titleArea = "_ff-1";
export var titleAreaWithHandle = "_ff-2";